module.exports = __webpack_public_path__ + "img/T2D_rc_24.66ce487f.png";